import React, { useEffect, useState } from 'react';
import SessionManager from '../routes/SessionManager';

function UserIcon() {
    const [name, setName] = useState('');
    const [user, setUser] = useState({});

    useEffect(() => {
        var sessionMgr = new SessionManager();
        setUser(sessionMgr.readCookie('user'));
    }, []);

    useEffect(() => {
        if (user) {
            setName(user.user_name);
        }
    }, [user]);

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            <i className="fa fa-user" style={{ fontSize: '14px' }} />
            {name}
        </span>
    );
}

export default UserIcon;